import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import App from "@/App";
import { store } from "@/store/store";
import queryClient from "@/queryClient";
import OuterErrorBoundary from "@/components/error/OuterErrorBoundary";
import EnvironmentRibbon from "@/components/layout/EnvironmentRibbon";
import AppVersionReload from "@/components/layout/AppVersionReload";
import { applySiteIdentity } from "@/utils/siteIdentity";
import { mountSandboxHost } from "@/agent/sandboxMount";
import "./index.css";

applySiteIdentity(import.meta.env);
mountSandboxHost(store);

// Stripe.js loads on every page from the start, as it always did, except on a fill link's page
// (index.html's first script decides: the link's secret is on that page). Billing's loadStripe
// ("@stripe/stripe-js/pure") then reuses this script. The only value import of the eager entry:
// a test holds the rest of src/ to that.
if (!(window as Window & { __steddyNoThirdParty?: boolean }).__steddyNoThirdParty) {
  void import("@stripe/stripe-js");
}

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

root.render(
  <React.StrictMode>
    <EnvironmentRibbon />
    <AppVersionReload />
    <QueryClientProvider client={queryClient}>
      <Provider store={store}>
        <BrowserRouter>
          <OuterErrorBoundary>
            <App />
          </OuterErrorBoundary>
        </BrowserRouter>
      </Provider>
    </QueryClientProvider>
  </React.StrictMode>
);
